import { render } from "./PushNotificationButton.vue?vue&type=template&id=ce974bd0&scoped=true"
import script from "./PushNotificationButton.vue?vue&type=script&lang=js"
export * from "./PushNotificationButton.vue?vue&type=script&lang=js"

import "./PushNotificationButton.vue?vue&type=style&index=0&id=ce974bd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce974bd0"]])

export default __exports__